import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { FundingTransfersTable } from '../../../../../../../../../../../../features/funding/transfer/funding-transfers-table';
import { AccountPortfolioAssetBalanceHeader } from '../../../../../../../../../../../../features/registration/account/account-portfolio-asset-balance-header';
import type { ViewContext } from '../../../../../../../../../../../../util/view-context';

export const Route = createFileRoute(
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/funding',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance,
      label: 'Funding',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance>,
  component: AccountAssetFundingList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { accountId, assetId } = Route.useParams();
  return <AccountPortfolioAssetBalanceHeader accountId={accountId} assetId={assetId} filter={filter} />;
}

function AccountAssetFundingList() {
  const { accountId } = Route.useParams();

  const viewContext = useMemo(
    () =>
      ({
        kind: 'account',
        accountId,
      }) as const satisfies ViewContext,
    [accountId],
  );

  return (
    <PageLayout.Section noBorder>
      <FundingTransfersTable HeaderActions={TableHeader} view={viewContext} />
    </PageLayout.Section>
  );
}
